import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "project-tasks-section" }
const _hoisted_2 = { class: "project-tasks-section__main" }

import { TasksKanban, TasksKanbanExternalSettings } from "@/components";
import EditQueueModal from "@/components/edit-queue-modal/edit-queue-modal.vue";
import { useSidebarTree } from "@/components/sidebar/composables";
import { QueueTasksModel } from "@/components/sidebar/models";
import { onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'kanban-page',
  props: {
  /**ID очереди */
  queueId: {
    type: String,
    required: true,
  },
  /**ID проекта */
  projectId: {
    type: Number,
    required: true,
  },
  /**ID неймспейса */
  namespaceId: {
    type: String,
    required: true,
  },
  namespaceName: {
    type: String,
    required: true,
  },
},
  emits: ["toggle-submenu", "open-options"],
  setup(__props, { emit }) {

const props = __props;




/**Id редактируемой очереди */
const editQueue = ref<QueueTasksModel>();
/**
 * * Закрыть окно редактирования очереди
 */
const closeEditQueueModal = () => (editQueue.value = undefined);
const tasksKanbanSettings: TasksKanbanExternalSettings = {
  showNestedTasks: true,
};
const { sidebarItems } = useSidebarTree();
function onOpenOptionsQueue(queueId) {
  // emit("open-options", queueId);
  openEditQueueModal();
}
const queueCurrent = ref(new QueueTasksModel());
watch(
  () => props.namespaceName,
  async () => {
    // isAdminNamespace.value = await adapter.checkNamespaceAdmin(props.namespaceId);
    queueCurrent.value = new QueueTasksModel({
      Id: route.params.queueId.toString(),
      NamespaceId: route.params.namespaceId.toString(),
      Name: props.namespaceName,
    });
  },
);
const route = useRoute();
/**
 * * Открытие окна для редактирования очереди
 */
function openEditQueueModal() {
  const res = localStorage.getItem("queueModel");
  let queue;
  if (res) {
    queue = JSON.parse(res);
  }
  queueCurrent.value = new QueueTasksModel({
    Id: route.params.queueId.toString(),
    NamespaceId: route.params.namespaceId.toString(),
    Name: queue?.Name ? queue.Name : "undefined",
  });
  editQueue.value = queueCurrent.value;

  // editQueue.value = props.menuItem;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(TasksKanban), {
          settings: tasksKanbanSettings,
          "queue-id": __props.queueId,
          "project-id": __props.projectId,
          "namespace-id": __props.namespaceId,
          namespaceName: props.namespaceName,
          onToggleSubmenu: _cache[0] || (_cache[0] = ($event: any) => (emit('toggle-submenu', $event))),
          onOpenOptions: openEditQueueModal
        }, null, 8, ["queue-id", "project-id", "namespace-id", "namespaceName"])
      ])
    ]),
    _createVNode(EditQueueModal, {
      queue: editQueue.value,
      onClose: closeEditQueueModal
    }, null, 8, ["queue"])
  ], 64))
}
}

})